import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Philippine UMID generator following Single Responsibility Principle
 */
export class PhGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate first 11 digits
    const digits = this.randomDigits(11);
    
    // Calculate Luhn check digit
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    const umid = digits + checkDigit;

    return formatted ? 
      `${umid.substring(0, 4)}-${umid.substring(4, 11)}-${umid.substring(11, 12)}` : 
      umid;
  }
}